import React, { useCallback, useState } from "react";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import isEmpty from "../../../store/validation/is-Empty";
import {
  TextField,
  FormHelperText,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  IconButton,
  OutlinedInput,
  InputAdornment,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
// import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { useEffect } from "react";
import Debounce from "../../../function/debounce";

//formulario
const theme = createTheme({
  overrides: {
    PrivateNotchedOutline: {
      legend: {
        width: "265px !important",
      },
    },
  },
});

export const InputBoxComponent = ({
  controlId,
  displayLabel,
  labelText,
  showLabelSmall,
  showLabelSmallText,
  inputType,
  inputClassName,
  placeHolder,
  name,
  value,
  onChange,
  error,
  disabled,
  required,
  passwordIcon,
  slashEyeIcon,
  passwordShow,
  passwordHide,
  showBottom,
  showBottomText,
  min,
  max,
  maxLength,
  onFocusOut,
  onKeyUp,
  onKeyDown,
}) => {
  return (
    <React.Fragment>
      <Form.Group
        className="reusableInputComponent-main mb-0"
        controlId={controlId}
      >
        {displayLabel === true ? (
          <Form.Label className="input-component-labeltext inline-css mt-3">
            {labelText}
            {showLabelSmall === true ? (
              <Form.Text className="ml-0 text-muted input-component-smalltext input-component-smalltext-onboarding">
                {showLabelSmallText}
              </Form.Text>
            ) : null}
          </Form.Label>
        ) : "" || displayLabel === "displayLabelNone" ? (
          <Form.Label className="ml-0 input-component-labeltext-transparent">
            {labelText}
          </Form.Label>
        ) : (
          ""
        )}

        <Form.Row className="input-component-insideRow">
          <Form.Control
            className={inputClassName}
            type={inputType}
            placeholder={placeHolder}
            name={name}
            value={value}
            min={min}
            max={max}
            maxLength={maxLength}
            onBlur={onFocusOut}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            onChange={onChange}
            disabled={disabled === true ? { disabled } : false}
            required={required === true ? required : ""}
          />
          {passwordIcon ? (
            // <i onClick={passwordShow} className="fa fa-eye password-icon"></i>
            <Image
              className="password-icon"
              onClick={passwordShow}
              src={require("../../../assets/images/Icon/openeye.png")}
              alt="passwordIcon"
              fluid
            />
          ) : null}
          {slashEyeIcon ? (
            // <i
            //   onClick={passwordHide}
            //   className="fa fa-eye-slash password-icon"
            // ></i>
            <Image
              className="password-icon"
              onClick={passwordHide}
              src={require("../../../assets/images/Icon/closedeye.png")}
              alt="passwordIcon"
              fluid
            />
          ) : null}
        </Form.Row>
        {showBottom === true ? (
          <Form.Text className={"text-muted input-component-bottom"}>
            {showBottomText}
            {error ? (
              <div className="text-danger text-capitalize">{error}</div>
            ) : null}
          </Form.Text>
        ) : (
          <Form.Text className="text-muted input-component-bottom position-absolute">
            {showBottomText}
            {error ? (
              <div className="text-danger text-capitalize">{error}</div>
            ) : null}
          </Form.Text>
        )}
      </Form.Group>
    </React.Fragment>
  );
};

export const TextAreaReusableComponent = ({
  controlId,
  displayText,
  labelText,
  labelSmall,
  labelTextClass,
  placeholder,
  rows,
  name,
  onChange,
  value,
  disabled,
  inputClassName,
  onFocusOut,
  error,
}) => {
  return (
    <React.Fragment>
      <Form.Group controlId={controlId} className="mb-0">
        {displayText === true ? (
          <div>
            <Form.Label className={labelTextClass}>{labelText}</Form.Label>
            <p className="input-component-smalltext-onboarding">{labelSmall}</p>
          </div>
        ) : null}
        <Form.Control
          as="textarea"
          placeholder={placeholder}
          rows={rows}
          name={name}
          onBlur={onFocusOut}
          onChange={onChange}
          value={value}
          disabled={disabled === true ? { disabled } : false}
          className={inputClassName}
        />
      </Form.Group>
      <Form.Text className="text-muted input-component-bottom">
        {error ? (
          <div className="text-danger text-capitalize">{error}</div>
        ) : null}
      </Form.Text>
    </React.Fragment>
  );
};

//{
/****************************
 * @DESC Select Category Box
 *****************************/
//}

export const SelectCategory = ({
  controlId,
  inputlabelclass,
  labeltext,
  name,
  inputClass,
  onChange,
  error,
  value,
  allcategoryList,
  selectedname,
  onFocusOut,
}) => {
  // console.log(allcategoryList);
  return (
    <React.Fragment>
      <Form.Group
        className="reusableInputComponent-main mb-0"
        controlId={controlId}
      >
        <label className={inputlabelclass} htmlFor={name}>
          {labeltext}
        </label>
        <Form.Row className="input-component-insideRow">
          <select
            value={value}
            className={inputClass}
            name={name}
            onChange={onChange}
            style={{ color: "#495057" }}
            onBlur={onFocusOut}
          >
            <option value="" disabled style={{ color: "#495057" }}>
              Select Category
            </option>
            {!isEmpty(allcategoryList) &&
              allcategoryList.map((categorydata, index) => {
                return (
                  <option key={index} value={categorydata._id}>
                    {categorydata.category_name}
                  </option>
                );
              })}
          </select>
        </Form.Row>
        <Form.Text className="text-muted input-component-bottom">
          {error ? (
            <div className="text-danger text-capitalize">{error}</div>
          ) : null}
        </Form.Text>
      </Form.Group>
    </React.Fragment>
  );
};

export const NewInputText = ({
  extraClass,
  labelWidth,
  name,
  inputType,
  helpTextDisplay,
  helperTextBottom,
  autoComplete,
  autoFocus,
  onChange,
  value,
  min,
  max,
  maxLength,
  onFocusOut,
  onKeyUp,
  onKeyDown,
  controlClass,
  labelText,
  multiline,
  rows,
  errorTrue,
  errorText,
  disabled,
  isInvalid,
  onBlur,
  onInput,
  placeholder,
  onKeyPress,
  InputLabelProps,
  onpaste,
  required,
  // inputProps,
}) => {
  const [focus, setFocus] = useState(false);
  return (
    <React.Fragment>
      <div
        className={`new_Input_field_Section ${extraClass ? extraClass : ""} ${
          (value || focus) && `mobile-view-width-border-spacing-textfield`
        }`}
      >
        <ThemeProvider theme={labelText && theme}>
          <TextField
            error={errorTrue ? true : false}
            fullWidth
            placeholder={placeholder}
            id={controlClass}
            type={inputType ? inputType : ""}
            autoComplete={autoComplete}
            autoFocus={autoFocus}
            name={name}
            label={labelText ? labelText : ""}
            key={labelText}
            value={value}
            onChange={onChange}
            helperText={errorText}
            variant="outlined"
            min={min}
            max={max}
            onFocus={() => setFocus(true)}
            inputProps={{ maxLength: maxLength }}
            // InputProps={{ inputProps: inputProps }}
            onBlur={(e) => {
              setFocus(false);
              if (onFocusOut) {
                onFocusOut(e);
              }
            }}
            onKeyUp={onKeyUp}
            onKeyPress={onKeyPress}
            onKeyDown={onKeyDown}
            multiline={multiline ? true : false}
            rows={rows}
            disabled={disabled === true ? true : false}
            onInput={onInput}
            shrink
            InputLabelProps={
              (inputType === "date" || inputType === "time") && { shrink: true }
            }
            onPaste={onpaste}
            required={required}
          />{" "}
        </ThemeProvider>
        {helpTextDisplay ? (
          <FormHelperText id="component-helper-text">
            {helperTextBottom}
          </FormHelperText>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export const PasswordReusableInput = ({
  extraClass,
  labelText,
  inputTypeState,
  value,
  name,
  handleChange,
  handleClickShowPassword,
  handleMouseDownPassword,
  onFocusOut,
  errorTrue,
  errorText,
  wLabel,
  onKeyPress,
}) => {
  return (
    <React.Fragment>
      <FormControl
        variant="outlined"
        className={`new_Input_field_Section ${extraClass ? extraClass : ""}`}
      >
        <InputLabel
          className="outlined-adornment-password-back"
          htmlFor="outlined-adornment-password"
        >
          {labelText}
        </InputLabel>
        <OutlinedInput
          error={errorTrue ? true : false}
          id="outlined-adornment-password"
          type={inputTypeState ? "text" : "password"}
          value={value}
          name={name}
          onBlur={onFocusOut}
          onChange={handleChange}
          inputProps={{
            maxLength: 32,
          }}
          onKeyPress={onKeyPress}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {inputTypeState ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
          labelWidth={wLabel}
        />
        {errorTrue ? (
          <FormHelperText
            id="outlined-error-helper-text"
            style={{ color: "#f44336" }}
          >
            {errorText}
          </FormHelperText>
        ) : null}
      </FormControl>
    </React.Fragment>
  );
};

export const SelectBoxMUiInputComponent = ({
  selectLabel,
  name,
  value,
  onChange,
  getData,
  errorTrue,
  errorText,
  extraClass,
  displayNone,
  onClick,
  disabled,
}) => {
  return (
    <React.Fragment>
      <FormControl
        variant="outlined"
        fullWidth
        error={errorTrue ? true : false}
        className={
          extraClass === true
            ? "single-select-box-material"
            : "select-box-material-hieght"
        }
        onClick={onClick}
      >
        <InputLabel id="demo-simple-select-outlined-label">
          {selectLabel}
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          name={name}
          value={value}
          onChange={onChange}
          label={selectLabel}
          IconComponent={KeyboardArrowDownIcon}
          disabled={disabled}
        >
          {displayNone === true ? null : (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}
          {!isEmpty(getData) &&
            getData.map((allData, index) => {
              return (
                <MenuItem key={index} value={allData.value}>
                  {allData.name}
                </MenuItem>
              );
            })}
        </Select>
        <FormHelperText
          id="outlined-error-helper-text"
          style={{ color: "#f44336" }}
        >
          {errorText}
        </FormHelperText>
      </FormControl>
    </React.Fragment>
  );
};

export const SelectBoxCategoryMui = ({
  selectLabel,
  name,
  value,
  onChange,
  getData,
  errorTrue,
  errorText,
  extraClass,
  disabled,
}) => {
  return (
    <React.Fragment>
      <FormControl
        variant="outlined"
        fullWidth
        error={errorTrue ? true : false}
        className={
          extraClass === true
            ? "single-select-box-material"
            : "select-box-material-hieght"
        }
        disabled={disabled}
      >
        <InputLabel id="demo-simple-select-outlined-label">
          {selectLabel}
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          name={name}
          value={value}
          onChange={onChange}
          label={selectLabel}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {!isEmpty(getData) &&
            getData.map((allData, index) => {
              return (
                <MenuItem key={index} value={allData}>
                  {allData}
                </MenuItem>
              );
            })}
        </Select>
        <FormHelperText>{errorText}</FormHelperText>
      </FormControl>
    </React.Fragment>
  );
};

export const NewSelectBoxInput = ({
  selectLabel,
  name,
  value,
  onChange,
  getCountries,
  en,
  errorTrue,
  errorText,
}) => {
  const [countriesList, setList] = useState([]);

  useEffect(() => {
    let c = [];
    getCountries().map((e) => c.push(en[e]));
    setList(c.sort());
  }, []);

  return (
    <React.Fragment>
      <FormControl
        variant="outlined"
        fullWidth
        error={errorTrue ? true : false}
      >
        <InputLabel id="demo-simple-select-outlined-label">
          {selectLabel}
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          name={name}
          value={value}
          onChange={onChange}
          label={selectLabel}
          IconComponent={KeyboardArrowDownIcon}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {countriesList.map((country) => (
            <MenuItem key={country} value={country}>
              {country}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{errorText}</FormHelperText>
      </FormControl>
    </React.Fragment>
  );
};

export const ReusableSlidingSearchComponent = ({
  isActive,
  setActive,
  setSearch,
  search,
  onChange,
  placeholder,
}) => {
  const debounceOnChange = useCallback(Debounce(onChange, 1000), []);
  return (
    <div className={`newexpandablesearch ${isActive ? "active" : null} mb-2`}>
      <div className="searchicon">
        <i
          onClick={() => {
            setActive(!isActive);
            setSearch("");
          }}
          className="fa fa-search"
          aria-hidden="true"
          style={{ fontSize: "20px" }}
        ></i>
      </div>
      <div className="input">
        <Form.Control
          type="text"
          placeholder={placeholder || "Search"}
          className="newsearchinput"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            debounceOnChange(e.target.value);
          }}
          style={{ borderRadius: "28px" }}
        />
        <i className="fa fa-timesw" aria-hidden="true"></i>
      </div>
    </div>
  );
};
